import { t } from 'localization/utils/t';

const TP = 'homepage.utils.getOrgSchema';

export const getOrgSchema = () => {
  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: t(`${TP}.goat`, 'GOAT'),
    description: t(
      `${TP}.description`,
      'GOAT is the global platform for the greatest products from the past, present and future. Since its founding in 2015, GOAT has become the leading and most trusted sneaker marketplace in the world, and has expanded to offer apparel and accessories from select emerging, contemporary and iconic brands.',
    ),
    foundingDate: t(`${TP}.foundingDate`, 'July 2015'),
    foundingLocation: t(`${TP}.foundingLocation`, 'Los Angeles, CA'),
    founders: [
      {
        '@type': 'Person',
        name: 'Eddy Lu',
      },
      {
        '@type': 'Person',
        name: 'Daishin Sugano',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: t(`${TP}.streetAddress`, '3433 W Exposition Pl'),
      addressLocality: t(`${TP}.addressLocality`, 'Los Angeles'),
      addressRegion: t(`${TP}.addressRegion`, 'CA'),
      postalCode: t(`${TP}.postalCode`, '90018'),
      addressCountry: t(`${TP}.addressCountry`, 'USA'),
    },
    brand: {
      '@type': 'Organization',
      name: 'GOAT',
    },
    logo: 'https://www.goat.com/public/images/seo/GOAT.png',
    url: 'https://www.goat.com',
    sameAs: [
      'https://www.facebook.com/goatapp',
      'https://twitter.com/goatapp',
      'https://www.instagram.com/goat',
    ],
  });
};
